import React, { useState, useEffect } from 'react';
import logoImage from '../../assets/mnm-logo.png';

const MnMLoader = ({ isComplete }) => {

  return (
    <div style={styles.container}>
      <div
        className={isComplete ? 'logo-container complete' : 'logo-container'}
        style={styles.logoContainer}
      >
        {/* <svg
          className="outer-circle"
          viewBox="25 25 50 50"
          style={{
            ...styles.outerCircle,
            ...(isComplete && styles.outerCircleComplete)
          }}
        >
          <circle
            className="circle-path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            strokeWidth="4"
            strokeLinecap="round"
          />
        </svg> */}

        {/* Show logo image when complete */}
        {isComplete ? (
          <img
            src={logoImage}
            alt="MnM Logo"
            style={styles.completedLogo}
          />
        ) : (
          /* Show animated squares during loading */
          <div className="loader" style={styles.loader}>
            {[1, 2, 3, 4, 5].map((num) => (
              <div
                key={num}
                className={`loader-square square-${num}`}
                style={{
                  ...styles.loaderSquare,
                  // Commented out: individual square completion positions
                  // ...(isComplete && styles[`loaderSquareComplete${num}`]),
                  animation: isComplete
                    ? 'none'
                    : `square-animation 6s ease-in-out infinite both, color-change 6s ease-in-out infinite both`,
                  animationDelay: `${-0.8 * (num - 1)}s`
                }}
              />
            ))}
          </div>
        )}
      </div>

      <style>{`
        @keyframes rotate-circle {
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes dash {
          0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
          }
          50% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -35px;
          }
          100% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -124px;
          }
        }

        @keyframes stroke-color {
          0%, 20% { stroke: rgba(244, 180, 26, 1); }
          20%, 40% { stroke: rgba(63, 169, 245, 1); }
          40%, 60% { stroke: rgba(233, 66, 53, 1); }
          60%, 80% { stroke: rgba(66, 133, 244, 1); }
          80%, 100% { stroke: rgba(52, 168, 83, 1); }
        }

        @keyframes square-animation {
          0% { left: 0; top: 0; }
          10.5% { left: 0; top: 0; }
          12.5% { left: 4px; top: 0; }
          23% { left: 4px; top: 0; }
          25% { left: 8px; top: 0; }
          35.5% { left: 8px; top: 0; }
          37.5% { left: 8px; top: 4px; }
          48% { left: 8px; top: 4px; }
          50% { left: 4px; top: 4px; }
          60.5% { left: 4px; top: 4px; }
          62.5% { left: 4px; top: 8px; }
          73% { left: 4px; top: 8px; }
          75% { left: 0; top: 8px; }
          85.5% { left: 0; top: 8px; }
          87.5% { left: 0; top: 4px; }
          98% { left: 0; top: 4px; }
          100% { left: 0; top: 0; }
        }

        @keyframes color-change {
          0%, 20% { background: rgba(244, 180, 26, 0.7); }
          20%, 40% { background: rgba(63, 169, 245, 0.7); }
          40%, 60% { background: rgba(233, 66, 53, 0.7); }
          60%, 80% { background: rgba(66, 133, 244, 0.7); }
          80%, 100% { background: rgba(52, 168, 83, 0.7); }
        }
 
        .outer-circle {
          animation: rotate-circle 0.5s linear infinite;
          transform-origin: center;
        }

        .circle-path {
          animation: dash 1.5s ease-in-out infinite, stroke-color 7.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'transparent',
    padding: 0,
    margin: 0,
  },

  logoContainer: {
    position: 'relative',
    width: '28px',
    height: '28px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  outerCircle: {
    position: 'absolute',
    width: '30px',
    height: '30px',
    opacity: 1,
    top: '-8px',
    left: '-4px',
    bottom: '6px',
    right: '2px',
  },

  outerCircleComplete: {
    animation: 'none',
    opacity: 0,
  },

  loader: {
    position: 'relative',
    width: '30px',
    height: '18px',
    transform: 'rotate(45deg)',
  },

  loaderSquare: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '5px',
    height: '5px',
    margin: '0.5px',
    borderRadius: '1.5px',
    background: 'white',
    opacity: 1,
  },

  // M Pattern completion - upright M with square boxes (no tilt)
  loaderSquareComplete1: {
    left: '0px',
    top: '10px',
    background: 'rgba(251, 188, 4, 0.9)',
    transform: 'rotate(0deg)',
  },

  loaderSquareComplete2: {
    left: '5px',
    top: '0px',
    background: 'rgba(66, 133, 244, 0.9)',
    transform: 'rotate(0deg)',
  },

  loaderSquareComplete3: {
    left: '10px',
    top: '5px',
    background: 'rgba(234, 67, 53, 0.9)',
    transform: 'rotate(0deg)',
  },

  loaderSquareComplete4: {
    left: '15px',
    top: '0px',
    background: 'rgba(66, 133, 244, 0.9)',
    transform: 'rotate(0deg)',
  },

  loaderSquareComplete5: {
    left: '20px',
    top: '10px',
    background: 'rgba(52, 168, 83, 0.9)',
    transform: 'rotate(0deg)',
  },

  // Logo image style when complete
  completedLogo: {
    width: '22px',
    height: 'auto',
    objectFit: 'contain',
  },

  // Commented out: Alternative - keep loaderSquareComplete positions
  // To use animated squares instead of logo image, remove the conditional
  // rendering in JSX and uncomment the loaderSquareComplete styles usage
};

export default MnMLoader;
